import { render, staticRenderFns } from "./goManage.vue?vue&type=template&id=a4998866&scoped=true"
import script from "./goManage.vue?vue&type=script&lang=js"
export * from "./goManage.vue?vue&type=script&lang=js"
import style0 from "./goManage.vue?vue&type=style&index=0&id=a4998866&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4998866",
  null
  
)

export default component.exports